export function getVehicleViolations(vehicle) {
    if (!vehicle || typeof vehicle !== 'object') return []

    const violations = new Set()

    const flagKeys = [
        'overloadSA',
        'overloadMA',
        'overloadTL',
        'overheight',
        'overlane',
        'overload',
        'overspeed',
        'wrongdirection'
    ]

    // 1. Proste flagi
    flagKeys.forEach(key => {
        if (vehicle[key] === true) {
            violations.add(key)
        }
    })

    // 2. Total load
    const hasTotalLoadViolation =
        typeof vehicle.totalLoad === 'number' &&
        typeof vehicle.limitTotalLoad === 'number' &&
        vehicle.totalLoad >= vehicle.limitTotalLoad

    if (hasTotalLoadViolation) {
        violations.add('overloadTL')
    }

    // 3. Axles
    const groups = vehicle.axlesComplex?.axlesGroups

    if (Array.isArray(groups)) {
        const axleOverload = groups.some(group =>
            group?.overload === true ||
            (Array.isArray(group?.axles) &&
                group.axles.some(axle => axle?.overload === true))
        )

        if (axleOverload) {
            violations.add('overload')
        }
    }

    return Array.from(violations)
}

export function hasViolation(vehicle) {
    return getVehicleViolations(vehicle).length > 0
}
